export default "__VITE_ASSET__69b413cd__"